module.exports = __webpack_public_path__ + "img/24514316000160.447f805f.png";